import { getLocaleString } from 'utilities/locales';

const createCurrencyFormatter = (locale, options) => {
  try {
    return new Intl.NumberFormat(locale, options);
  } catch {
    return new Intl.NumberFormat(locale, {
      ...options,
      currencyDisplay: 'symbol',
    });
  }
};

// We bypass the shared `toCurrency` helper because it always emits two
// fraction digits for USD ("$49.00") - the blockcell mock and design intent
// is to drop trailing zeros on whole-dollar amounts ("$49"). Mirrors the
// Safari narrowSymbol fallback from utilities/currency.js.
export const formatTierMonthlyPrice = (tier) => {
  const hasMonthlyCents =
    tier?.monthly_cents !== null && tier?.monthly_cents !== undefined;
  const hasCurrency = Boolean(tier?.currency);
  if (!hasMonthlyCents || !hasCurrency) return null;

  const locale = getLocaleString();
  const baseOptions = {
    style: 'currency',
    currency: tier.currency,
    ...(tier.currency === 'CAD' && { currencyDisplay: 'narrowSymbol' }),
  };
  const formatter = createCurrencyFormatter(locale, baseOptions);
  const fractionDigits = formatter.resolvedOptions().maximumFractionDigits;
  const minorUnitFactor = 10 ** fractionDigits;
  const amount = tier.monthly_cents / minorUnitFactor;
  const minimumFractionDigits =
    tier.monthly_cents % minorUnitFactor === 0 ? 0 : fractionDigits;
  const options = {
    ...baseOptions,
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits,
  };

  return createCurrencyFormatter(locale, options).format(amount);
};

export const formatProcessingRateParts = (rate) => {
  const hasVariableBasisPoints =
    rate?.variable_basis_points !== null &&
    rate?.variable_basis_points !== undefined;
  const hasFixedCents =
    rate?.fixed_cents !== null && rate?.fixed_cents !== undefined;
  if (!hasVariableBasisPoints || !hasFixedCents) return null;

  const percentage = new Intl.NumberFormat(getLocaleString(), {
    maximumFractionDigits: 2,
    minimumFractionDigits: rate.variable_basis_points % 100 === 0 ? 0 : 1,
  }).format(rate.variable_basis_points / 100);

  return {
    percentage,
    fixedCents: rate.fixed_cents,
  };
};
